<script lang="ts">
	import type { ChartConfiguration } from 'chart.js';
	import Chart from './Chart.svelte';

	interface Props {
		dividendPayoutRatioHistory: DividendPayoutRatioYear[];
	}

	let { dividendPayoutRatioHistory }: Props = $props();

	const defaultConfig: Omit<ChartConfiguration, 'data'> = {
		type: 'bar',
		options: {
			plugins: {
				legend: {
					position: 'bottom',
					labels: {
						boxWidth: 9,
						boxHeight: 9
					}
				},
				tooltip: {
					callbacks: {
						label: function (context) {
							const label = context.dataset.label ?? '';
							if (label) {
								return `${label}: ${new Intl.NumberFormat('default', {
									style: 'percent'
								}).format(context.dataset.data[context.dataIndex] as number)}`;
							}
							return '';
						}
					}
				}
			},
			responsive: true,
			maintainAspectRatio: false,
			scales: {
				y: {
					ticks: {
						callback: function (value) {
							return new Intl.NumberFormat('default', {
								style: 'percent'
							}).format(Number(value));
						}
					}
				},
				x: {
					type: 'category',
					border: {
						display: false
					},
					grid: {
						display: false
					},
					ticks: {
						autoSkip: false,
						crossAlign: 'far'
					}
				}
			},
			indexAxis: 'x'
		}
	};

	let labels = $derived(dividendPayoutRatioHistory.map(({ year }) => year));
	let data = $derived(dividendPayoutRatioHistory.map(({ payoutRatio }) => payoutRatio));
</script>

<Chart
	config={{
		...defaultConfig,
		options: {
			...defaultConfig.options
		}
	}}
	data={{
		labels,
		datasets: [
			{
				label: 'Dividend payout ratio',
				backgroundColor: '#00523D',
				borderRadius: 4,
				borderSkipped: false,
				data
			}
		]
	}}
/>
